import React, { useEffect, useState } from "react";

import {  Edit, Trash2 ,FilePlus} from "react-feather";
import { Tooltip } from "react-tooltip";
import { ToastContainer, toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  delete_manufactured_products_api,
  get_common_attributes_api,
  get_manufactured_products_api,
  get_toolcategories_api,
  get_toolsubcategories_api,
  get_tooltype_api,
  update_manufactured_products_api,
} from "../../Config/API";
import { calMaxPage } from "../../Common/CommonFunction";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SearchableSelect from "../../Components/SerachableSelect";

import * as yup from "yup";
import CustomTypeahead from "../../Components/CustomeTypehead";

export const MyProducts = ({toggle}) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [srNo, setSrNo] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [common_attributes, setCommon_attributes] = useState({
    data: [],
    loading: false,
  });
  const [tool_material_list, setTool_material_list] = useState([]);
  const [toolTypeList, setToolTypeList] = useState({ data: [], loading: true });
  const [toolCatList, setToolCatList] = useState({ data: [], loading: true });
  const [toolSubCatList, setToolSubCatList] = useState({
    data: [],
    loading: true,
  });
  const [filterCatList, setfilterCatList] = useState({
    data: [],
    loading: false,
  });
  const [filterSubCatList, setfilterSubCatList] = useState({
    data: [],
    loading: false,
  });
  const [uom, setuom] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModaldata] = useState({});
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const [button_click, setButton_click] = useState(false);
  const [filterConfig, setFilterConfig] = useState({
    tool_type: [],
    tool_category: [],
    tool_subcategory: [],
    excludeManufactured: false,
  });
  const [dataList, setDataList] = useState({
    data: [],
    loading: true,
    totalRecords: "",
  });

  const schema = yup
    .object()
    .shape({
      max_cutter_diameter: yup
        .number()
        .typeError("Max cutter diameter must be a number !")
        .required("Max cutter diameter is required !")
        .positive("Max cutter diameter must be a positive number !")
        .integer("Max cutter diameter must be an integer !"),
      min_cutter_diameter: yup
        .number()
        .typeError("Min cutter diameter must be a number !")
        .required("Min cutter diameter is required !")
        .positive("Min cutter diameter must be a positive number !")
        .integer("Min cutter diameter must be an integer !"),
      min_shank_diameter: yup
        .number()
        .typeError("Min shank diameter must be a number !")
        .required("Min shank diameter is required !")
        .positive("Min shank diameter must be a positive number !")
        .integer("Min shank diameter must be an integer !"),
      max_shank_diameter: yup
        .number()
        .typeError("Max shank diameter must be a number !")
        .required("Max shank diameter is required !")
        .positive("Max shank diameter must be a positive number !")
        .integer("Max shank diameter must be an integer !"),
      min_overall_length: yup
        .number()
        .typeError("Min overall length must be a number !")
        .required("Min overall length is required !")
        .positive("Min overall length must be a positive number !")
        .integer("Min overall length must be an integer !"),
      max_overall_length: yup
        .number()
        .typeError("Max overall length must be a number !")
        .required("Max overall length is required !")
        .positive("Max overall length must be a positive number !")
        .integer("Max overall length must be an integer !"),
      cutter_diameter_uom: yup
        .string()
        .required("Unit of measurement is required !")
        .oneOf(["mm", "inch"], "Invalid unit of measurement !"),
      overall_length_uom: yup
        .string()
        .required("Unit of measurement is required !")
        .oneOf(["mm", "inch"], "Invalid unit of measurement !"),
      shank_diameter_uom: yup
        .string()
        .required("Unit of measurement is required !")
        .oneOf(["mm", "inch"], "Invalid unit of measurement !"),
      tool_material: yup
        .string()
        .required("Tool material is required !")
        .oneOf(tool_material_list, "Invalid tool material !"),
    })
    .required();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {},
  });

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchProductList(1, entriesPerPage);
    }, 1000); // Adjust the delay as needed (e.g., 500 milliseconds)

    return () => {
      clearTimeout(debounceTimeout); // Clear the timeout if searchTerm changes before the timeout expires
    };
  }, [filterConfig]);

  useEffect(() => {
    fetch_attributes();
    fetchToolCats();
    fetchToolTypes();
    fetchToolSubCats();
  }, []);
  const handle_onchange2 = (attributeName, value, option) => {
    console.log(`attributeName`, attributeName);
    console.log(`value`, value);
    console.log(`option`, option);

    if (attributeName == "Search by tool type" && option == null) {
      setFilterConfig({ ...filterConfig, tool_type: [] });
      setfilterCatList({ data: [], loading: false });
      setfilterSubCatList({ data: [], loading: false });
    } else if (attributeName == "Search by tool category" && option == null) {
      setfilterSubCatList({ data: [], loading: false });
      setFilterConfig({ ...filterConfig, tool_category: [] });
    } else if (
      attributeName == "Search by tool sub-category" &&
      option == null
    ) {
      setFilterConfig({ ...filterConfig, tool_subcategory: [] });
    }

    if (attributeName == "Search by tool type" && option !== null) {
      setFilterConfig({ ...filterConfig, tool_type: [option] });
      filter_lists(option.uuid, "ToolCategory");
    } else if (attributeName == "Search by tool category" && option !== null) {
      setFilterConfig({ ...filterConfig, tool_category: [option] });
      filter_lists(option.tool_type, "ToolSubCategory", option.uuid);
    } else if (
      attributeName == "Search by tool sub-category" &&
      option !== null
    ) {
      setFilterConfig({ ...filterConfig, tool_subcategory: [option] });
    }
  };

  function fetch_attributes() {
    setCommon_attributes({ data: [], loading: true });

    get_common_attributes_api().then(
      (res) => {
        // console.log("res", res.data);
        let arr = res.data.data.filter(
          (item) => item.manufactured_products == true
        );
        let arr2 = arr.filter((item) => item.attribute_name == "Tool Material");

        // console.log("arr2",arr2);
        let arr3 = [];
        if (arr2.length > 0) {
          if (arr2[0].attribute_value.length > 0) {
            arr3 = arr2[0].attribute_value.map((item) => item.value);
          }
        }

        // console.log('arr3',arr3)
        setTool_material_list(arr3);

        if (arr.length > 0 && arr[0].uom_values) {
          let arr2 = [];
          if (arr[0].uom_values.length > 0) {
            arr2 = arr[0].uom_values.map((item) => item.name);
          }
          // console.log('arr2',arr2)
          setuom(arr2);
        }

        setCommon_attributes({
          loading: false,
          data: arr,
        });
      },
      (err) => {
        setCommon_attributes({
          loading: false,
          data: [],
        });
      }
    );
  }

  function fetchToolTypes() {
    get_tooltype_api().then(
      (res) => {
        setToolTypeList({
          ...toolTypeList,
          loading: false,
          data: res.data.data,
        });
      },
      (err) => {
        console.log("err", err);
        setToolTypeList({ ...toolTypeList, loading: false, data: [] });
      }
    );
  }

  function fetchToolCats() {
    get_toolcategories_api().then(
      (res) => {
        setToolCatList({ loading: false, data: res.data.data });
      },
      (err) => {
        setToolCatList({ loading: false, data: [] });
      }
    );
  }

  function fetchToolSubCats() {
    get_toolsubcategories_api().then(
      (res) => {
        //console.log("res", res);

        setToolSubCatList({
          loading: false,
          data: res.data.data,
        });
      },
      (err) => {
        console.log("err", err);
        setToolSubCatList({ loading: false, data: [] });
      }
    );
  }

  const filter_lists = (id, type, id2) => {
    if (type == "ToolCategory") {
      setfilterCatList({ data: [], loading: true });

      let arr = toolCatList.data.filter((item) => item.tool_type == id);
      console.log("arr", arr);
      setfilterCatList({ data: arr, loading: false });
    } else {
      setfilterSubCatList({ data: [], loading: true });

      let arr2 = toolSubCatList.data.filter(
        (item) => item.tool_type == id && item.tool_category == id2
      );
      console.log("arr", arr2);

      setfilterSubCatList({ data: arr2, loading: false });
    }
  };

  function fetchProductList(pg, epp) {
    setDataList({ ...dataList, loading: true, data: [] });

    const payload = {
      page: pg,
      limit: epp,
    };

    if (filterConfig.tool_type.length > 0) {
      payload.tool_type = filterConfig.tool_type?.[0]?.uuid;
    } else {
      delete payload.tool_type;
    }

    if (filterConfig.tool_category.length > 0) {
      payload.tool_category = filterConfig.tool_category?.[0]?.uuid;
    } else {
      delete payload.tool_category;
    }

    if (filterConfig.tool_subcategory.length > 0) {
      payload.tool_subcategory = filterConfig.tool_subcategory?.[0]?.uuid;
    } else {
      delete payload.tool_subcategory;
    }

    get_manufactured_products_api(payload).then(
      (res) => {
        // console.log("res", res.data.data);
        console.table(res.data.data)
        setDataList({
          ...dataList,
          loading: false,
          data: res.data.data,
          totalRecords: res.data.total,
        });
        // console.log("calMaxPage(res.data.total)",calMaxPage(res.data.total))
        setMaxPage(calMaxPage(res.data.total));
        if (pg == 1) {
          setSrNo(0);
          setPage(1);
        }
      },
      (err) => {
        setDataList({
          ...dataList,
          loading: false,
          data: [],
          totalRecords: "",
        });
      }
    );
  }

  const onSubmit = (data) => {
    console.log(data);
    setButton_click(true);

    const payload = {
      ...data,
      product_id: modalData.product_id,
      uuid: modalData.uuid,
    };

    console.log("payload", payload);
    update_manufactured_products_api(payload)
      .then((res) => {
        console.log("res", res);
        setButton_click(false);
        closeModal();
        toast.success("Manufactured product updated successfully !", {
          autoClose: 2000,
        });
        fetchProductList(page, entriesPerPage);
      })
      .catch((err) => {
        console.log("err", err);
        setButton_click(false);
        if (err?.response?.data?.message) {
          toast.error(err.response.data.message, {
            autoClose: 2000,
          });
        } else {
          toast.error("Something went wrong !", {
            autoClose: 2000,
          });
        }
      });
  };

  const del_my_products = (val) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record !",
      icon: "warning",
      confirmButtonColor: "rgb(38 171 131)",
      cancelButtonColor: "#807e7ed7",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        // Firing delete api
        const payload = {
          uuid: val.uuid,
        };
        delete_manufactured_products_api(payload).then(
          (res) => {
            toast.success("My product deleted successfully !", {
              autoClose: 3000,
            });
            if (dataList.data.length == 1 && page > 1) {
              fetchProductList(page - 1, entriesPerPage);
              setSrNo(parseInt(srNo - entriesPerPage));
              setPage(page - 1);
            } else {
              fetchProductList(page, entriesPerPage);
            }
          },
          (err) => {
            if (err.response.status === 400) {
              toast.error(err.response.data.message, {
                autoClose: 2000,
              });
            } else {
              toast.error("Something went wrong ", {
                autoClose: 2000,
              });
            }
          }
        );
      }
    });
  };

  return (
    <div className="px-10 py-2 h-full overflow-y-auto pb-[10%] ">
      <ToastContainer />

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-5/6 h-5/6 flex flex-col">
            {/* <div className="bg-white rounded-lg shadow-lg w-3/4 h-3/4 relative"> */}
            {/* Modal Header */}
            <div className="p-2 border-b flex justify-between items-center">
              <h3 className="text-xl font-semibold">Edit My Product</h3>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ×
              </button>
            </div>

            {/* Modal Body */}
            <div className="flex-grow p-3 overflow-y-auto">
              {" "}
              {/* Added mb-12 to provide space for the footer */}
              <div className="flex justify-center mb-3">
                <img
                  src={modalData?.product_info.product_image}
                  alt="Placeholder"
                  className="myproductimg"
                />
              </div>
              {/* Row 1 */}
              <div className="grid grid-cols-3 gap-4 mb-1">
                <div>
                  <label
                    htmlFor="max_cutter_diameter"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Max Cutter Diameter
                  </label>
                  <input
                    name="max_cutter_diameter"
                    id="max_cutter_diameter"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter max cutter"
                    defaultValue={modalData.max_cutter_diameter}
                    {...register("max_cutter_diameter")}
                  />

                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.max_cutter_diameter?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="min_cutter_diameter"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Min Cutter Diameter
                  </label>
                  <input
                    name="min_cutter_diameter"
                    id="min_cutter_diameter"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter min cutter"
                    defaultValue={modalData.min_cutter_diameter}
                    {...register("min_cutter_diameter")}
                  />
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.min_cutter_diameter?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="cutter_diameter_uom"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    UOM
                  </label>

                  <select
                    id="cutter_diameter_uom"
                    name="cutter_diameter_uom"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    defaultValue={modalData.cutter_diameter_uom}
                    {...register("cutter_diameter_uom")}
                  >
                    <option value="">Select UOM...</option>
                    {uom.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>

                  {errors.cutter_diameter_uom && (
                    <span className="text-danger" style={{ fontSize: "10px" }}>
                      {errors.cutter_diameter_uom?.message}
                    </span>
                  )}
                </div>
              </div>
              {/* Row 2 */}
              <div className="grid grid-cols-3 gap-4 mb-1">
                <div>
                  <label
                    htmlFor="max_shank_diameter"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Max Shank Diameter
                  </label>
                  <input
                    name="max_shank_diameter"
                    id="max_shank_diameter"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter max shank"
                    defaultValue={modalData.max_shank_diameter}
                    {...register("max_shank_diameter")}
                  />
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.max_shank_diameter?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="min_shank_diameter"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Min Shank Diameter
                  </label>
                  <input
                    name="min_shank_diameter"
                    id="min_shank_diameter"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter min shank"
                    defaultValue={modalData.min_shank_diameter}
                    {...register("min_shank_diameter")}
                  />
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.min_shank_diameter?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="shank_diameter_uom"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    UOM
                  </label>
                  <select
                    id="shank_diameter_uom"
                    name="shank_diameter_uom"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    defaultValue={modalData.shank_diameter_uom}
                    {...register("shank_diameter_uom")}
                  >
                    <option value="">Select UOM...</option>
                    {uom.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                  {errors.shank_diameter_uom && (
                    <span className="text-danger" style={{ fontSize: "10px" }}>
                      {errors.shank_diameter_uom?.message}
                    </span>
                  )}
                </div>
              </div>
              {/* Row 3 */}
              <div className="grid grid-cols-3 gap-4 mb-0">
                <div>
                  <label
                    htmlFor="max_overall_length"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Max OAL
                  </label>
                  <input
                    name="max_overall_length"
                    id="max_overall_length"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter max OAL"
                    defaultValue={modalData.max_overall_length}
                    {...register("max_overall_length")}
                  />
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.max_overall_length?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="min_overall_length"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    Min OAL
                  </label>
                  <input
                    id="min_overall_length"
                    name="min_overall_length"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    placeholder="Enter min OAL"
                    defaultValue={modalData.min_overall_length}
                    {...register("min_overall_length")}
                  />
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    {errors.min_overall_length?.message}
                  </span>
                </div>
                <div>
                  <label
                    htmlFor="overall_length_uom"
                    className="block text-gray-700 font-medium mb-1"
                  >
                    UOM
                  </label>
                  <select
                    id="overall_length_uom"
                    name="overall_length_uom"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    defaultValue={modalData.overall_length_uom}
                    {...register("overall_length_uom")}
                  >
                    <option value="">Select UOM...</option>
                    {uom.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                  {errors.overall_length_uom && (
                    <span className="text-danger" style={{ fontSize: "10px" }}>
                      {errors.overall_length_uom?.message}
                    </span>
                  )}
                </div>
              </div>
              {/* Row 4 */}
              <div className="grid grid-cols-3 gap-4 mb-0 ">
                <div>
                  <label
                    htmlFor="tool_material"
                    className="block text-gray-700 font-medium mb-1 ml-2"
                  >
                    Tool Material
                  </label>
                  <select
                    id="tool_material"
                    name="tool_material"
                    className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                    defaultValue={
                      modalData.tool_material && modalData.tool_material
                    }
                    {...register("tool_material")}
                  >
                    <option value="">Select Tool Material...</option>
                    {tool_material_list.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                  {errors.tool_material && (
                    <span className="text-danger" style={{ fontSize: "10px" }}>
                      {errors.tool_material?.message}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="p-3 border-t flex justify-end bg-white">
              <button
                style={
                  button_click
                    ? { backgroundColor: "#807e7ed7" }
                    : { backgroundColor: "rgb(38, 171, 131)" }
                }
                className="px-4 py-2 text-white rounded hover:bg-green-700"
                disabled={button_click}
                onClick={handleSubmit(onSubmit)}
              >
                Include
              </button>
            </div>
          </div>
        </div>
      )}

      <h1 className="mb-3 text-4xl">My Products</h1>
      {/* Filters Section */}
      <div className="mb-5 flex flex-wrap gap-4">
        <div>
          <SearchableSelect
            item={{
              attribute_name: "Search by tool type",
              attribute_value: toolTypeList.data.map((item) => {
                let obj = { ...item, name: item.tool_type_name };
                return obj;
              }),
            }}
            handle_onchange={handle_onchange2}
            placeholder={"Select tool type"}
          />
        </div>
        <div>
          <SearchableSelect
            item={{
              attribute_name: "Search by tool category",
              attribute_value: filterCatList.data.map((item) => {
                let obj = { ...item, name: item.description };
                return obj;
              }),
            }}
            handle_onchange={handle_onchange2}
            placeholder={"Select tool category"}
          />
        </div>
        <div>
          <SearchableSelect
            item={{
              attribute_name: "Search by tool sub-category",
              attribute_value: filterSubCatList.data.map((item) => {
                let obj = { ...item, name: item.description };
                return obj;
              }),
            }}
            handle_onchange={handle_onchange2}
            placeholder={"Select tool sub-category"}
          />
        </div>

        {/* <div className="mt-2">
          <label for="one">
            <input
              id="one"
              type="checkbox"
              onChange={(e) => {
                setFilterConfig({
                  ...filterConfig,
                  excludeManufactured: e.target.checked,
                });

                console.log("e.target", e.target.checked);
              }}
            />
            Included
          </label>
        </div> */}

        {/* <button
          onClick={clearFilter}
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-red-600"
        >
          Reset Filters
        </button> */}
      </div>
      <div className="h-full w-full">
        <div className="overflow-x-auto ">
          {dataList.loading ? (
            <div className="text-center ">
              <svg
                aria-hidden="true"
                className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : dataList?.data?.length > 0 ? (
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                  <th className="border border-gray-300 px-4 py-2">Sr.No</th>
                  <th className="border border-gray-300 px-4 py-2">
                    Tool Type
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Tool Category
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Tool Sub Category
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Product Code
                  </th>

                  <th className="border border-gray-300 px-4 py-2 ">Action</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {dataList.data.map((item, i) => (
                  <tr key={item.uuid}>
                    <td className="border border-gray-300 px-4 py-2">
                      {i + Number(srNo) + 1}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item?.product_info?.tooltypedata?.tool_type_name
                        ? item?.product_info?.tooltypedata?.tool_type_name
                        : "NA"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item?.product_info?.toolcategory?.description
                        ? item?.product_info?.toolcategory?.description
                        : "NA"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item?.product_info?.toolsubcategory?.description
                        ? item.product_info?.toolsubcategory.description
                        : "NA"}
                    </td>

                    <td className="border border-gray-300 px-4 py-2">
                      {item.product_info.product_code}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <div className="flex">
                        <>
                          <Tooltip id={"edit-tooltip" + i} place="top" />
                          <Edit
                            data-tooltip-id={"edit-tooltip" + i}
                            data-tooltip-content={"Edit My Product"}
                            className=" cursor-pointer m-2"
                            color="#807e7ed7"
                            size={20}
                            onClick={() => {
                              console.log("edit");
                              setModaldata(item);
                              reset();
                              openModal();
                            }}
                          />
                        </>
                        <>
                          <Tooltip id={"delete-tooltip" + i} place="top" />

                          <Trash2
                            data-tooltip-id={"delete-tooltip" + i}
                            data-tooltip-content={"Delete My Product"}
                            className=" cursor-pointer m-2"
                            onClick={() => {
                              del_my_products(item);
                            }}
                            color="#807e7ed7"
                            size={20}
                          />
                        </>
                        <>
                          <Tooltip
                            id={"create-quotation-tooltip" + i}
                            place="top"
                          />

                          <FilePlus
                            data-tooltip-id={"create-quotation-tooltip" + i}
                            data-tooltip-content={"Create Quotation"}
                            className=" cursor-pointer m-2"
                            onClick={() => {
                              navigate(
                                `/product/${item.product_info.tool_subcategory}`,
                                {
                                  state: {
                                    path_arr: [
                                      item?.product_info?.tooltypedata
                                        ?.tool_type_name,
                                      item?.product_info?.toolcategory
                                        ?.description,
                                      item.product_info?.toolsubcategory
                                        .description,
                                    ],
                                  },
                                }
                              );
                              toggle()
                            }}
                            color="#807e7ed7"
                            size={20}
                          />
                        </>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="w-full flex align-center">
              <div className="py-4 text-center">
                <h1 className="catLable mt-5 text-3xl font-semibold ">
                  {`No my products found !`}
                </h1>
              </div>
            </div>
          )}
        </div>
        {dataList.loading ? null : dataList.data?.length > 0 ? (
          <div className="mt-4 flex justify-between items-center ">
            <p>{`Showing ${parseInt(srNo) + 1} to ${
              dataList.data.length + entriesPerPage * page - entriesPerPage
            } of ${dataList.totalRecords} entries`}</p>
            <div className="flex justify-evenly w-1/4">
              <button
                className={
                  page == 1
                    ? `w-full secondary-color  p-2  text-white  cursor-pointer`
                    : `main-color  w-full  p-2  text-white  cursor-pointer`
                }
                disabled={page === 1 ? true : false}
                onClick={() => {
                  fetchProductList(
                    page - 1,
                    entriesPerPage,
                    parseInt(srNo) - parseInt(entriesPerPage)
                  );
                  setSrNo((prevC) =>
                    page - 1 == 1 ? 0 : prevC - parseInt(entriesPerPage)
                  );
                  setPage(page - 1);
                }}
              >
                {"Prev"}
              </button>

              <button
                className="w-full  p-2  text-black  cursor-pointer"
                disabled={true}
              >
                {" "}
                {page}{" "}
              </button>

              <button
                className={
                  page == maxPage
                    ? `w-full  secondary-color  p-2  text-white  cursor-pointer`
                    : `main-color  w-full  p-2  text-white  cursor-pointer`
                }
                disabled={page == maxPage ? true : false}
                onClick={() => {
                  fetchProductList(
                    page + 1,
                    entriesPerPage,
                    parseInt(srNo) + parseInt(entriesPerPage)
                  );
                  setSrNo((prevC) => prevC + parseInt(entriesPerPage));
                  setPage(page + 1);
                }}
              >
                {"Next"}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
